<ngx-loading-bar [includeSpinner]="false" [height]="'2px'" [color]="'#ffffff'"></ngx-loading-bar>
<app-header-admin></app-header-admin>
<section class="pt-5">
    <div class="container">
        <div class="row">
            <div *ngIf="ruta!=='tours-register' && ruta!=='tour-itinerario' && ruta!=='tours-update' && ruta!=='tour-excursiones'" class="col-12 mb-5">
                <div style = "float: left">
                    <h3 class="text-primary" style="color: #00008b !important">Hola, BHI</h3>
                </div>
                <div style = "float: right">
                    <a *ngIf="ruta==='tours' || ruta==='packs'" [routerLink]="['/','admin', 'tours-register']" 
                        class="btn btn-lg rounded-pill btn-outline-secondary border-2 text-center btn-reservar align-self-center mt-lg-0 mt-4">Nuevo viaje +</a>
                    <a *ngIf="ruta==='agencias' || ruta==='agencias-pendientes' || ruta==='perfil' || ruta==='perfil-pendiente'" [routerLink]="['/','admin', 'agencias-pendientes']"
                        class="me-md-3 btn btn-lg rounded-pill border-2 text-center btn-reservar align-self-center mt-lg-0 mt-4 btn-outline-secondary">Solicitudes pendientes</a>
                    <a style="cursor: pointer;" *ngIf="ruta==='agencias' || ruta==='agencias-pendientes' || ruta==='perfil' || ruta==='perfil-pendiente'" (click)="openRegister()"
                        class="btn btn-lg rounded-pill border-2 text-center btn-reservar align-self-center mt-lg-0 mt-4 btn-outline-secondary">Nueva agencia +</a>
                </div>
            </div>
            <div *ngIf="menu" class="col-lg-3 col-xxl-3 d-none d-md-block z-index--top">
                <app-menu-admin></app-menu-admin>
            </div>
            <div [class.col-lg-12]="!menu" [class.col-lg-9]="menu" [class.col-xxl-9]="menu" [class.border-2]="menu"
               [class.border-left]="menu" [class.border-start]="menu" [class.ps-lg-4]="menu" [class.ps-lg-4]="menu" [class.z-index--top]="menu">
                <router-outlet></router-outlet>
            </div>                                      
        </div>
        <div class="row">
        </div>
    </div>
</section>
<section class="bg-home admin-user" style="height: 350px;">
    <div class="container z-index--top" style="margin-top: -40px;">
        <div class="row mt-5">
            <div class="col-12 text-center z-index--top">
                <a style="cursor: pointer;" *ngIf="ruta==='perfil-pendiente'" (click)="aprobar()" class="me-2 btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Aprobar</a>
                <a style="cursor: pointer;"  *ngIf="ruta==='perfil-pendiente' || ruta==='perfil'" (click)="eliminar()" class="btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Dar de baja</a>               
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
